export const ShopType = {
    INDIVIDUAL: 'individual',
    COMPANY: 'company',
    PARTNERSHIP: 'partnership'
};

export const ShopStatus = {
    PENDING: 'pending',
    ACTIVE: 'active',
    BANNED: 'banned',
    REJECTED: 'rejected'
};
